import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Sgke101aRequest, Sgke101aResponseReceivableInfo, Sgke101aResponseSearchResultList,
  Sgke102aRequest, Sgke102aRequestReceivableInfo, Sgke102aRequestReginf,
  Sgke103aRequest, Sgke103aRequestApprvInfo, Sgke103aRequestReceivableInfo
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke101aService } from '../../services/used-sgke101-a.service';
import { UsedSgke102aService } from '../../services/used-sgke102a.service';
import { UsedSgke103aService } from '../../services/used-sgke103a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke100d',
  templateUrl: './sgke100d.component.html',
  styleUrl: './sgke100d.component.scss'
})
export class Sgke100dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();


  /**  検索結果リスト */
  searchResultList: Array<Sgke101aResponseSearchResultList>;

  /** 一覧検索リクエスト */
  private request: Sgke101aRequest;

  /** 速報取消・速報取消承認フラグ ・速報取消画面：「未承認」 false ・速報取消承認画面：「承認依頼中」 true */
  isApproval: boolean = false;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route
   * @param {UsedSgke101aService} searchService
   * @param {UsedSgke102aService} registService
   * @param {UsedSgke103aService} approvalService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke100dComponent
   */
  constructor(
    private route: ActivatedRoute,
    public searchService: UsedSgke101aService,
    public registService: UsedSgke102aService,
    public approvalService: UsedSgke103aService,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
  }

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.isApproval = params.get('mode') == DisplayMode.approve ? true : false;
      // 遷移時に渡された値を元に、速報取消か速報取消承認かを判定 isApprovalがTRUE（承認）なら'1'
      let realtimeCancelStatuscode = this.isApproval ? '1' : '0';

      // リクエスト情報をもつオブジェクトを定義
      this.request = {
        requestCommon: {
          businessDate: null,
          dryRun: false,
          businessReqId: null,
          funcLinkId: null,
          requestCustomize: null,
        },
        cndt: {
          realtimeCancelStatuscode: realtimeCancelStatuscode
        }
      };

      // 一覧検索を起動
      this.search(this.request);
    });

  }

  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 一覧検索処理
   *
   * @private
   * @param {Sgke101aRequest} request
   * @memberof Sgke100dComponent
   */
  private search(request: Sgke101aRequest) {

    // searchResultList初期化
    this.searchResultList = new Array<Sgke101aResponseSearchResultList>();

    this.searchService.doSgke101a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {

          if (response.searchResult && response.searchResult.searchResultList.length !== 0) {
            this.searchResultList = response.searchResult.searchResultList;
          } else if (this.searchResultList) {
            this.searchResultList.length = 0;
          }
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

        }
      },
      error => {
      }
    );
  }


  /**
   * 登録ボタン押下処理
   *
   * @param {Sgke101aResponseSearchResultList[]} selected
   * @memberof Sgke100dComponent
   */
  onClickRegist(selected: Sgke101aResponseSearchResultList[]): void {

    // エラーメッセージクリア
    this.clearErrorMsg();

    // 未収情報 生成関数
    let receivableInfoFunc = function (info: Sgke101aResponseReceivableInfo): Sgke102aRequestReceivableInfo {
      return {
        kinkoMno: info.kinkoMno,
        kinkoRrkno: info.kinkoRrkno,
        kinkoUpdateSrno: info.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: info.kinkoexUpdatesequencenumber
      };
    }
    // 登録情報 生成関数
    let requestFunc = function (row: Sgke101aResponseSearchResultList): Sgke102aRequestReginf {
      return {
        receivableInfo: row.receivableInfo.map(receivableInfoFunc),
        inmny: row.inmny,
        kinko: row.kinko
      };
    }

    // 登録リクエストDTO作成
    let sgke102aRequest: Sgke102aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      reginf: selected.map(requestFunc)
    }

    // 登録処理を呼び出し
    this.regist(sgke102aRequest);
  }

  /**
   * 登録処理
   *
   * @private
   * @param {Sgke102aRequest} request
   * @memberof Sgke100dComponent
   */
  private regist(request: Sgke102aRequest) {
    this.registService.doSgke102a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

          // 一覧を再検索
          this.search(this.request);
        }
      },
      error => {
      }
    )
  }

  /**
   * 承認ボタン押下処理
   *
   * @param {Sgke101aResponseSearchResultList[]} selected
   * @memberof Sgke100dComponent
   */
  onClickApploval(selected: Sgke101aResponseSearchResultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 未収情報 生成関数
    let receivableInfoFunc = function (info: Sgke101aResponseReceivableInfo): Sgke103aRequestReceivableInfo {
      return {
        rcvResultMno: info.rcvResultMno,
        kinkoMno: info.kinkoMno,
        kinkoRrkno: info.kinkoRrkno,
        kinkoUpdateSrno: info.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: info.kinkoexUpdatesequencenumber
      };
    }
    // 承認情報 生成関数
    let requestFunc = function (row: Sgke101aResponseSearchResultList): Sgke103aRequestApprvInfo {
      return {
        rcvInfoNo: row.rcvInfoNo,
        rcvMnyUpdateSrno: row.rcvMnyUpdateSrno,
        receivableInfo: row.receivableInfo.map(receivableInfoFunc),
      };
    }

    // 承認リクエストDTO作成
    let sgke103aRequest: Sgke103aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      apprvInfo: selected.map(requestFunc)
    }

    // 承認処理を呼び出し
    this.approval(sgke103aRequest);

  }

  /**
   * 承認処理
   *
   * @private
   * @param {Sgke103aRequest} request
   * @memberof Sgke100dComponent
   */
  private approval(request: Sgke103aRequest) {
    this.approvalService.doSgke103a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

        // 一覧を再検索
        this.search(this.request);
      },
      error => {
      });
  }

  /**
   * エラーメッセージ表示領域をクリア
   *
   * @private
   * @memberof Sgke100dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray.length = 0;
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }



}
